import { useState } from 'react';
import {
  Typography,
} from '@mui/material';
import './EditableSingleFieldForm.scss';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import SingleFieldFormComponent from './SingleFieldForm';
import { filterUndefined } from '../../utils/FilterUndefinedObject';

/**
 * Ediable single form component
 * When the component is in the display mode, it display as a text with an icon
 * indicating the form can be editted.
 */
const defaultProps = {
  formData: '',
  placeholderLabel: '',
  placeholderColor: 'initial',
  className: '',
  title: '',
  children: null,
};

export default function EditableSingleFieldForm(props) {
  const {
    formData,
    handleSaveData,
    label,
    placeholderLabel,
    placeholderColor,
    className,
    title,
    children,
  } = { ...defaultProps, ...filterUndefined(props) };
  const [editMode, setEditMode] = useState(false);

  const editFormMode = () => {
    setEditMode(true);
  };

  const handleSave = (data) => {
    handleSaveData(data);
    setEditMode(false);
  };

  const handleOnBlur = (event) => {
    handleSave(event.target.value);
  };

  return (
    <div className={`editable-form ${className}`}>
      {title && (
        <Typography variant='h5' className='form-title editable-field-title' data-test='editable-field-title'>{title}: </Typography>
      )}
      {children}
      {
        editMode
          ? (
            <SingleFieldFormComponent
              label={label}
              formData={formData}
              handleSubmit={handleSave}
              onBlur={handleOnBlur}
            />
          ) : (
            <div className='editable-form-display'>
              <Typography color={formData ? 'initial' : `${placeholderColor}`} variant='h5' className='form-title'>{formData || placeholderLabel}</Typography>
              <BorderColorIcon
                className='edit-icon'
                onClick={editFormMode}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.stopPropagation();
                    e.preventDefault();
                    editFormMode();
                  }
                }}
                data-test='edit-action'
                // eslint-disable-next-line
                tabIndex={1}
              />
            </div>
          )
      }

    </div>
  );
}
